import React from 'react';
import FilePreview from '../../../file-preview';
import { UploadFile } from '../../upload.types';
import { previewImage } from '../../upload.utils';

interface UploadFilePreviewProps {
  file: UploadFile<any>;
  onDelete: (file: UploadFile<any>) => void;
  onPreview: (file: UploadFile<any>) => void;
}

const UploadFilePreview: React.FunctionComponent<UploadFilePreviewProps> = ({
  file,
  onDelete,
  onPreview,
}) => {
  const [preview, setPreview] = React.useState<string | undefined>(undefined);
  const mounted = React.useRef(false);

  React.useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  React.useEffect(() => {
    if (!file.originFileObj) {
      return;
    }

    (async () => {
      const res = await previewImage(file.originFileObj as File);

      if (res && mounted.current) {
        setPreview(res);
      }
    })();
  }, [file.originFileObj]);

  return (
    <FilePreview
      mimeType={file.originFileObj?.type ?? ''}
      fileName={file.fileName ?? file.name}
      onDelete={() => onDelete(file)}
      onPreview={() => onPreview(file)}
      progress={file.percent}
      status={file.status}
      thumbnailUrl={preview}
    />
  );
};

export default React.memo(UploadFilePreview);
